import { z } from 'zod';

import type { ActivityDefinition } from './types.js';

import { draftFields } from './_shared.js';
import { activityIssue } from './types.js';

const issue = activityIssue('base_activity');

/**
 * The beat with no interaction: it talks, then moves on by itself. `outcomeId` names
 * which of the node's outcomes it finishes with — the only branch it can take, so an
 * id naming an outcome the writer never defined leaves the beat with nowhere to go.
 */
export const baseActivity: ActivityDefinition = {
  type: 'base_activity',
  summary: 'No interaction — the beat talks, then moves on by itself through one outcome.',
  setup: z.looseObject({
    ...draftFields,
    outcomeId: z.string().optional(),
  }),
  check: (setup, ctx) => {
    const outcomeId = typeof setup.outcomeId === 'string' ? setup.outcomeId.trim() : '';
    if (!outcomeId) {
      // The player falls back to the node's `default` route, so only a node without one is stuck.
      return ctx.outcomeIds && !ctx.outcomeIds.includes('default')
        ? [issue('outcome', 'No outcomeId is written and the node has no default route, so the beat has no way to move on.', [...ctx.path, 'setup', 'outcomeId'], ctx, setup.outcomeId)]
        : [];
    }
    if (!ctx.outcomeIds || ctx.outcomeIds.includes(outcomeId)) {
      return [];
    }
    return [issue(
      'unknownOutcome',
      `outcomeId '${outcomeId}' is not one of the node's outcomes (${ctx.outcomeIds.join(', ') || 'none'}).`,
      [...ctx.path, 'setup', 'outcomeId'],
      ctx,
      outcomeId,
    )];
  },
};
